export { default } from './DefaultCardTitle';
